import Vue from 'vue'
import { GET_USER, SET_USER, AUTH_LOGOUT } from '../variables'

export default {
	state: {
		user: null,
		partner: null,
	},
	getters: {
		user: (state) => state.user,
		partner: (state) => state.partner,
	},
	actions: {
		[AUTH_LOGOUT]: ({ commit }) => {
			return new Promise((resolve, reject) => {
				commit(SET_USER, null)
				resolve()
			})
		},
		[GET_USER]: ({ commit, dispatch }, id) => {
			return new Promise((resolve, reject) => {
				Vue.axios({
					url: 'proUsers/' + id,
					method: 'GET',
				})
					.then(async (resp) => {
						commit(SET_USER, resp.data)

						await dispatch('INIT', null, { root: true })

						resolve()
					})
					.catch((err) => {
						console.log('TEST ERRR', err)
						reject(err)
					})
			})
		},
	},

	mutations: {
		[SET_USER]: (state, data) => {
			state.user = data
		},
	},
}



// WEBPACK FOOTER //
// ./src/store/user.js